import type { ResolvedIntlConfig } from 'react-intl';

export const getTranslationMessages = async (locale: string) => {
  const messages: ResolvedIntlConfig['messages'] = {};

  try {
    const imports = await Promise.all([
      import(`@ps/web-help-components/intl/${locale}.json`),
      import(`@ps/web-shared-components/intl/${locale}.json`),
      import(`@ps/web-shared-validators/intl/${locale}.json`),
      import(`@ps/web-sports-quick-links/intl/${locale}.json`)
    ]);
    Object.assign(messages, ...imports.map((imp) => imp.default));
    return messages;
  } catch {
    return messages;
  }
};
